export default __webpack_public_path__ + "static/media/vivo_eight.fc5e30db.webp";